import { camelize } from 'services/string_utils'

import { generateSuggestTimesHtmlEmail, htmlToPlainText } from './html_email_generator'

export const determineTimezone = (
  timezone,
  lockTimezoneEnabled,
  lockTimezoneContent,
  availabilityTimezone) => timezone || (lockTimezoneEnabled ? lockTimezoneContent : availabilityTimezone)

export const processAvailabilityData = (
  data,
  locale,
  bookingUrl,
  timeNotation,
  currentTimezone) => {
  if (!data) return null

  const { availabilityData, datesWithSpots } = data
  const selectedTimezone = currentTimezone || availabilityData?.availabilityTimezone
  const groupedSpots = datesWithSpots || {}

  if (Object.keys(groupedSpots).length === 0) return null

  const htmlContent = generateSuggestTimesHtmlEmail(
    locale,
    bookingUrl,
    selectedTimezone,
    groupedSpots,
    timeNotation
  )

  return {
    ...data,
    generatedContent: {
      html: htmlContent,
      plainText: htmlToPlainText(htmlContent)
    }
  }
}

export const hasRequiredFields = (eventType, requiredFields) => {
  if (!eventType || typeof eventType !== 'object') {
    return false
  }

  const camelizedEventType = camelize(eventType)
  return requiredFields.every((field) => field in camelizedEventType)
}
